export const experience = [
  {
  role: "Senior Data Engineer",
  company: "Absolute Software",
  duration: "2025 – Present | Denver, CO",
  highlights: [
    "Leading the design and development of a multi-cloud Delta Lakehouse platform (AWS + Azure) powering analytics for millions of devices.",
    "Architecting governed data systems using Databricks, Delta Lake, Unity Catalog, and Terraform-based infrastructure automation.",
    "Building scalable ingestion pipelines (daily/hourly) with Spark (Scala/Python), structured streaming, and automated workflows.",
    "Driving governance and catalog automation, including catalog → schema → volume provisioning and service account/job orchestration.",
    "Mentoring engineers and partnering cross-functionally with Ops/Platform teams to improve reliability and cost efficiency.",
    "Improving data reliability, observability, and lineage through architectural patterns and monitoring enhancements."
  ],
  tech: "Databricks (Delta Lake + Unity Catalog) · Data Lakehouse Architecture · Apache Spark (Scala/Python) · NATS JetStream · AWS S3 · Microsoft Azure · Real-Time Data Pipelines · Terraform"
    },
  {
    role: "Software Application Engineer",
    company: "Absolute Software",
    duration: "2021 – 2025 | Denver, CO",
    highlights: [
      "Built the DataHauler platform, a modular Spark–Scala ingestion system integrating 6M+ devices telemetry data into a unified multi-cloud Delta Lakehouse.",
      "Designed a custom Spark flattener to process deeply nested JSON telemetry, initially written as Parquet for the legacy AWS data lake, later evolved to Delta tables with Unity Catalog.",
      "Led Salesforce data migration to Delta with zero data loss, automated validation, and schema reconciliation.",
      "Developed multi-layer anonymization pipelines ensuring privacy compliance without breaking lineage.",
      "Automated Unity Catalog registration, Z-ORDER, OPTIMIZE, and VACUUM jobs with Terraform.",
      "Architected hybrid AWS–Azure data lake with centralized governance and cross-workspace sharing.",
      "Partnered with data scientists to deliver curated datasets powering the Cyber Resilience Index 2025 report."
    ],
    tech: "Databricks (Delta Lake + Unity Catalog) · Delta Lake · Unity Catalog · Apache Spark (Scala/Python)  · NATS JetStream · AWS S3 · Azure ADLS · Airflow · Argo · Terraform"
  },
  {
    role: "Software Application Engineer",
    company: "Delta Information Systems",
    duration: "2020 – 2021 | Milton, GA",
    highlights: [
      "Developed and implemented application monitoring and performance management solutions, resulting in major improvements in system reliability and user experience.",
      "Engineered machine learning models tailored to customer-specific requirements, automating key processes and improving service efficiency.",
      "Designed and deployed cloud architectures using AWS and Azure services, optimizing scalability, resilience, and resource utilization.",
      "Automated infrastructure provisioning and deployment pipelines using Terraform, reducing manual efforts and minimizing configuration errors.",
      "Collaborated closely with development and operations teams to streamline DevOps practices, achieving faster and more reliable software delivery.",
      "Provided technical guidance and incident support during critical outages, troubleshooting and resolving complex issues to ensure uninterrupted client service."
    ],
    tech: "Python · AWS · Azure · Terraform · ML Models · DevOps · CI/CD · Cloud Architecture · Monitoring · Linux"
  },
  {
    role: "Software Engineer",
    company: "SeedBin",
    duration: "2019 – 2020 | Loveland, CO",
    highlights: [
      "Developed SeedBin’s inventory management and production planning SaaS platform using Django and Python.",
      "Built and maintained ETL jobs to ingest, transform, and load data from multiple data sources into the platform database.",
      "Designed data models and Django ORM logic to support analytics, inventory tracking, forecasting, and reporting.",
      "Developed REST API endpoints and optimized query performance for key business workflows."
    ],
    tech: "Python · Django · PostgreSQL · ETL Pipelines · REST APIs · Data Modeling · SQL"
  },
  {
    role: "Solar Sustainability App",
    company: "Jawaharlal Nehru Technological University, Hyderabad",
    duration: "2016 – 2017 | Hyderabad, India",
    highlights: [
      "Designed and developed a cross-platform Tizen application to promote renewable energy awareness and solar adoption.",
      "Built energy load, inverter sizing, and cost estimation calculators using JavaScript and HTML5.",
      "Integrated REST APIs and developed responsive dashboards visualizing daily energy generation and CO₂ offset.",
      "Deployed the app to the Tizen Store and documented system architecture and UX design."
    ],
    tech: "Java · HTML5 · JavaScript · CSS · Tizen SDK · REST APIs"
  }
];
